// 配项备份
// [T2ARMID]: {
//   id: T2ARMID,
//   label: 'T2业务-arm64',
//   prizeText: '现在加入T业务，成功上机即获25%额外奖励',
//   rule_link: 'https://help.yfanqie.com/f63a/d8b4',
//   resource_requirement: [
//     '长视频业务；',
//     '单线上行 50M/100M（一带一）或 100M（一带二）；',
//     'FX、赚钱宝Pro、WJY、树莓派4B等arm64位设备；',
//     '配置240G以上固态硬盘',
//   ],
// hasDetail: true,
// valid: true,
// className: 'part-b',
// advantages: [
//   {
//     icon: 'icon-10',
//     msg: ['小盒子挂机', '性价比之选'],
//   },
//   {
//     icon: 'icon-11',
//     msg: ['不限制区域'],
//   },
//   {
//     icon: 'icon-12',
//     msg: ['跑量稳定', '适合长期挂机'],
//   },
// ],
// detail: {
//   date: '2021年7月1日-2021年9月30日',
//   state: [
//     {
//       key: '',
//       value:
//         '上机奖励将分别在次月10日之前一次性发放，例如，7月的上机奖励，将在8月10日前发放；8月的上机奖励，将在9月10日前发放；9月的上机奖励，将在10月10日前发放。',
//     },
//   ],
//   spec_rule: [
//     '期间需要保持设备稳定在线，设备累计下线达到48小时，则奖励失效；',
//     '若提供的网络，设备质量达不到上游客户要求，将被清退到普通业务；',
//     '奖励计算根据实际业务情况而定，例如以7月奖励为例，若用户跑了15天普通业务，16天的定向业务，奖励计算如下：暑期上机奖励=15天的普通业务收益总和*15%+16天的定向业务收益总和*25%。',
//   ],
//   ps:"",
//   guarantee: [
//     'SLA1：18点-24点必须保持在线。若18-24点不在线超过5min，当天收益为0；',
//     'SLA2：每月若触发SLA1达到5天，若继续跑A业务，则后续每天收益为0，触发SLA2以后可及时切换业务止损；',
//     'SLA3：每月服务时间必须≥15天，若剩余天数未能达到15天的服务时间要求，则后续每天收益为0；',
//     '注意：所有设备、网络调整，请务必错开18点-24点！！！！！！',
//   ],
//   faq: [
//     {
//       question: 'Q：季度质量奖是怎么计算和发放的？',
//       answer:
//         'A：例如9、10、11月份都获得了月度质量奖金，可获得【（9月+10月+11月贡献收益的总和）*10%】的季度质量奖，并在12月15号之前发放到APP账号内；',
//     },
//     {
//       question: 'Q：奖励在哪里查看？',
//       answer:
//         'A：可在【昨日收益-收益明细】中查询到“额外奖励-月度质量奖”或“额外奖励-季度质量奖”或”额外奖励-日质量奖励“；',
//     },
//     {
//       question: 'Q：奖励什么时候发？',
//       answer:
//         'A：日奖励次日发放，月度奖励在次月的15日前发放，季度在满足月度奖励后次月15日前发放；',
//     },
//     {
//       question: 'Q：被清退后，还有奖励吗？',
//       answer:
//         'A：因资源质量不达标被清退，则当月月度质量奖清0；中断后若未达成连续3个月的目标，则季度质量奖失效，且重新开始计算3个月时长；',
//     },
//     {
//       question: 'Q：中途上线的设备，还能享受月度和季度奖励吗？',
//       answer: 'A：次月1日开始计算月度质量奖励；季度质量奖励发放后，将重新开始计算3个月时长。',
//     },
//   ],
// },

const HX86ID = '10010';
const GX86ID = '10007';
const BspX86ID = '10008';
const XWkyID = '100004';
const SuperDID = '10015';
const SuperAID = '10012';
const HsX86 = '10016';
const B2X86 = '10018';
const B6X86 = '10019';
const B8X86 = '10020';
const SuperKID = '10024';
const B3X86 = '10025';
const AX86 = '10026';
const B1WPX86 = '10027';
const BWPX86 = '10002';
const SuperSID = '10030';
const B5X86ID = '10031';
const X1X86 = '10032';
const SuperD2X86 = '10033';
const Z1X86ID = '10034';
const G2X86ID = '10035';
const DX86ID = '10009';
const T6X86ID = '10036';
const J2X86ID = '10037';
const JX86ID = '10028';
const SX86ID = '10001';
const ZARMID = '100003';
const ZX86ID = '10021';
const BopX86ID = '10023';
const BX86ID = '10003';
const T1ARMID = '100001';
const T1X86ID = '10005';
const T2ARMID = '100002';
const T2X86ID = '10006';
const T3X86ID = '10013';
const T4X86ID = '10014';
const T5X86ID = '10022';
const BSPYZ86ID = '10038';
const DzxX86ID = '10039';
const SzxX86ID = '10040';
const BSP2X86ID = '10041';
const G3X86ID = '10042';
const H2X86ID = '10043';
const Z1ARMID = '100005';
const Z2ARMID = '100006';
const Z3ARMID = '100007';
const SUPERLID = '10044';
const G3OESID = '100008';

export const BIZ_INFO_MAP = {
  [G3OESID]: {
    id: G3OESID,
    label: 'G3-OES业务',
    prizeText: 'OES首个优质业务，值得拥有！',
    rule_link: 'https://help.yfanqie.com/f63a/ceb6/G3-OES',
    resource_requirement: [
      '单线上行大小≥100M（华东/华南电信、西南/东北移动区域单线≥30M即可），单机总上行带≤200M',
      '需OES拨号或固定ip，NAT为全锥、映射公网、公网；',
      '需配置2块或以上的固态盘，4K随机读iops≥30000。',
    ],
  },
  [Z1ARMID]: {
    id: Z1ARMID,
    label: 'Z1业务-小盒子',
    prizeText: '超低门槛的小盒子定向业务！数量有限，先到先得！',
    rule_link: 'https://help.yfanqie.com/f63a/z1',
    resource_requirement: [
      '适用设备：仅限玩客云现金版，及赚钱宝3代设备；',
      '3天缓存部署期，3~7天起量；',
      '上行带宽要求：单线上行 ≥20M；',
      '磁盘要求：≥50G 固态硬盘，且磁盘读速度测试至少30M以上，写速度15M以上；',
      'Nat要求：原始全锥型，原始公网、或映射型公网型；',
    ],
  },
  [Z2ARMID]: {
    id: Z2ARMID,
    label: 'Z2业务-小盒子',
    prizeText: '优质小盒子定向业务！',
    rule_link: 'https://help.yfanqie.com/f63a/ceb6/z2',
    resource_requirement: [
      '适用设备：玩客云现金版，赚钱宝3代设备，赚钱宝3代pro设备，N1设备，WJY设备，LZY设备；',
      '3天缓存部署期，3~7天起量；',
      '上行带宽要求：单线上行 ≥30M；',
      '磁盘要求：≥240G 固态硬盘，且磁盘读速度测试至少30M以上，写速度15M以上；',
      'Nat要求：原始公网、或映射型公网型；',
    ],
  },
  [Z3ARMID]: {
    id: Z3ARMID,
    label: 'Z3业务-arm32',
    prizeText: '全新小盒子业务！高收益+10%奖励！',
    rule_link: 'https://help.yfanqie.com/f63a/Z3-arm32',
    resource_requirement: [
      '适用设备：仅限*玩客云现金版*，及*赚钱宝3代*设备；',
      '设备在线要求：8月19日至8月28日不在线的设备，或8月1日0点之后新上机的设备（8月1日之后在官方购买的福利购设备、福利码设备）；',
      '3天缓存部署期，3~7天起量；',
      '上行带宽要求：单线上行 30M（一带一）或50M（一带二）或100M（一带三），一带二以上的情况可设置upnp；',
      '磁盘要求：240G及以上SSD；',
      'Nat要求：原始NAT为全锥型，或UPNP后为全锥型、UPNP后为映射公网型、或DMZ公网。',
    ],
  },
  [T1ARMID]: {
    id: T1ARMID,
    label: 'T1业务-arm64',
    prizeText: '现在加入T业务，成功上机即获25%额外奖励',
    rule_link: 'https://help.yfanqie.com/f63a/10bf/T1-arm',
    resource_requirement: [
      '长视频业务；',
      '单线上行 50M/100M（一带一）或 100M（一带二）；',
      'FX、赚钱宝Pro、WJY、树莓派4B等arm64位设备；',
      '配置240G以上固态硬盘；',
    ],
  },
  [T2ARMID]: {
    id: T2ARMID,
    label: 'T2业务-arm64',
    prizeText: '现在加入T业务，成功上机即获25%额外奖励',
    rule_link: 'https://help.yfanqie.com/f63a/10bf/T1-arm',
    resource_requirement: [
      '长视频业务；',
      '单线上行 50M/100M（一带一）或 100M（一带二）；',
      'FX、赚钱宝Pro、WJY、树莓派4B等arm64位设备；',
      '配置240G以上固态硬盘',
    ],
  },
  [ZARMID]: {
    id: ZARMID,
    label: 'Z业务-arm32',
    prizeText: '收益+10%质量奖，小盒子专享业务',
    rule_link: 'https://help.yfanqie.com/f63a/c3ee',
    resource_requirement: [
      '适用设备：仅限*玩客云现金版*，及*赚钱宝3代*设备；',
      '设备在线要求：2022年7月17日 - 2022年7月26日不在线的设备，或 2022年6月1日之后在官方新购买的设备、福利码关联设备；',
      '3天缓存部署期，3~7天起量；',
      '上行带宽要求：单线上行 30M（一带一）或50M（一带二）或100M（一带三），一带二以上的情况可设置upnp；',
      '磁盘要求：240G及以上SSD；',
      'Nat要求：原始NAT为全锥型，或UPNP后为全锥型、UPNP后为映射公网型；',
      '联网方式：不支持设备直接拨号；',
      '路由器需支持动态分配ip。',
    ],
  },
  [XWkyID]: {
    id: XWkyID,
    label: 'X业务-arm32',
    rule_link: 'https://help.yfanqie.com/f63a/421b',
    prizeText: '上机即可额外享有【7月1日-9月30日收益*25%】的奖励',
    resource_requirement: [
      '长视频业务；',
      '单线上行 50M/100M（一带一）或 100M（一带二）；',
      '赚钱宝3代，玩客云现金版等arm32位设备；',
      '配置240G以上固态硬盘；',
    ],
  },
  [SX86ID]: {
    id: SX86ID,
    label: 'S业务-x86',
    prizeText: '专享收益+25%质量奖，招募区域广利用率高',
    rule_link: 'https://help.yfanqie.com/f63a/7807/S',
    resource_requirement: [
      '单线路上行带宽≥100M，单机带宽≥500M；',
      '支持服务器拨号或固定ip，原始nat为公网或全锥；',
      '1G配置1.5T SSD；',
      '3天起量期；',
    ],
  },
  [BWPX86]: {
    id: BWPX86,
    label: 'B网盘业务-x86',
    prizeText: '收益+10%质量奖，单线≥10M带宽专享业务',
    rule_link: 'https://help.yfanqie.com/f63a/7807/BWP',
    resource_requirement: [
      '单线路上行带宽≥10M；',
      '支持软路由拨号、服务器拨号或固定ip，nat全锥以上；',
      '1G配置20T硬盘，支持SSD、HDD；',
      '7天起量期，30天缓存期，缓存完成跑量会更稳；',
    ],
  },
  [BX86ID]: {
    id: BX86ID,
    label: 'B业务-x86',
    prizeText: '现在加入B业务，质量达标即送15%额外奖励',
    rule_link: 'https://help.yfanqie.com/f63a/7807/B',
    resource_requirement: [
      '业务类型为下载业务（需要上行带宽）；',
      '需要固态硬盘（io≥30000）+大容量HDD（企业级sas盘，≥7200转）；',
      '网络单线上行≥100M ，公网ip或nat全锥型，需服务器拨号。',
    ],
  },
  [T1X86ID]: {
    id: T1X86ID,
    label: 'T1业务-x86',
    rule_link: 'https://help.yfanqie.com/f63a/aec8',
    prizeText: '现在加入T业务，质量达标即送15%额外奖励',
    resource_requirement: [
      '长视频业务；',
      '单线带宽50M~500M之间（500M以上按500M算，500M以下按实际上行算）；',
      '固态硬盘，单盘存储大小必须为单线上行的1.5倍。（io≥30000）；',
    ],
  },
  [T2X86ID]: {
    id: T2X86ID,
    label: 'T2业务-x86',
    rule_link: 'https://help.yfanqie.com/f63a/aec8',
    prizeText: '现在加入T业务，质量达标即送15%额外奖励',
    resource_requirement: [
      '长视频业务；',
      '单线50M或100M 二选一（100M以下按50M算，100M以上按100M算）；',
      '固态硬盘，单线上行为50M，单盘存储大小为75G；单线上行为100M，单盘存储大小为150G。（io≥30000）；',
    ],
  },
  [GX86ID]: {
    id: GX86ID,
    label: 'G业务-x86',
    prizeText: '现在加入G业务，质量达标即送15%质量奖励',
    rule_link: 'https://help.yfanqie.com/f63a/7807/G',
    resource_requirement: [
      '专线或单线≥30Mbps（华北电信联通；华东电信移动、西南华南移动需单线≥50Mbps），汇聚≤40条线，电信联通需公网ip，移动全锥以上；',
      '动态ip必须使用服务拨号，静态/固定ip必须按照要求配置；',
      '硬盘要求：iops ≥40000，100Mbps需要对应100G SSD；',
    ],
  },
  [BspX86ID]: {
    id: BspX86ID,
    label: 'Bsp业务-x86',
    prizeText: '收益+15%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/7807/Bsp',
    resource_requirement: [
      '单线路上行带宽≥50M；',
      '支持服务器拨号或固定ip。nat为映射公网、公网；',
      '每1G配置2T SSD；',
      '缓存期为3天，缓存期后跑量会相对稳定；',
    ],
  },
  [BSP2X86ID]: {
    id: BSP2X86ID,
    label: 'Bsp2-x86',
    prizeText: '收益+15%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/7807/Bsp',
    resource_requirement: [
      '单线路上行带宽≥50M；',
      '服务器拨号或固定ip，原始nat全锥；',
      '每1G配置2T SSD；',
      '缓存期为3天，缓存期后跑量会相对稳定；',
    ],
  },
  [BSPYZ86ID]: {
    id: BSPYZ86ID,
    label: 'Bsp预招-x86',
    prizeText: '现在加入Bsp预招业务，质量达标即送15%质量奖励',
    rule_link: 'https://help.yfanqie.com/f63a/7807/Bsp',
    resource_requirement: [
      '专线或者单线≥50Mbps，汇聚≤40条线，电信联通需公网ip，移动全锥以上；',
      '动态ip必须使用服务拨号，静态/固定ip必须按照要求配置；',
      '推荐使用物理机，虚拟机需要开启mac地址欺骗（不会怎么开启的话直接用物理机）；',
      '每条线路配置1线程CPU，1.5G内存，100G SSD（iops≥30000），100M带宽至少对应100G SSD，1G带宽至少对应1T SSD，其他带宽以此类推。',
      '3天缓存期；',
    ],
  },
  [HX86ID]: {
    id: HX86ID,
    label: 'H业务-x86',
    prizeText: '收益+25%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/7807/H',
    resource_requirement: [
      '单线上行≥50M，单机2-4G；',
      '下行带宽≥上行带宽30%（例上行2G，下行需≥600M）；',
      '公网ip或全锥型；',
      '服务器拨号（动态ip选拨号，固定ip选静态设置）；',
    ],
  },
  [H2X86ID]: {
    id: H2X86ID,
    label: 'H2业务-x86',
    prizeText: 'H业务低配版，享收益+25%质量奖，还可软路由拨号',
    rule_link: 'https://help.yfanqie.com/f63a/7807/H',
    resource_requirement: [
      '单线上行≥50M，单机2-4G；',
      '下行带宽≥上行带宽30%（例上行2G，下行需≥600M）；',
      '公网ip或全锥型；',
      '适合软路由拨号（需配置一对一模式），再加盒子类设备复用带宽；',
      '不需要数据盘。',
    ],
  },
  [SuperAID]: {
    id: SuperAID,
    label: 'SuperA-x86',
    prizeText: '现在加入SuperA业务，质量达标即送15%额外奖励',
    rule_link: 'https://help.yfanqie.com/f63a/74fb',
    resource_requirement: [
      '长视频业务；',
      '单线带宽50M~500M之间（500M以上按500M算，500M以下按实际上行算）；',
      '固态硬盘，单盘存储大小必须为单线上行的倍数，且至少为2倍。（io≥30000）',
    ],
  },
  [SUPERLID]: {
    id: SUPERLID,
    label: 'SuperL-x86',
    prizeText: '优点只有一个就是高收益，专享收益+35%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/superL',
    resource_requirement: [
      '单线路上行带宽≥500M，单机1-3G内；',
      '服务器拨号，原始nat为公网；',
      '只需配置1T SSD；',
    ],
  },
  [T3X86ID]: {
    id: T3X86ID,
    label: 'T3业务-x86',
    rule_link: 'https://help.yfanqie.com/f63a/T3',
    prizeText: '现在加入T业务，质量达标即送25%额外奖励',
    resource_requirement: [
      '服务器拨号；',
      '电信和联通只要公网IP，西北和西南移动只要全锥，专线或单线上行≥200Mbps汇聚的宽带；',
      '固态盘的实际存储是汇聚带宽的2倍。例如：单个固态磁盘500G， 单线200M，那这个磁盘只能跑1条线(需400G)，剩余100G无法使用 ，每G固态盘(4K随机读写iops>30000，推荐nvme盘)，系统盘>=50G；',
    ],
  },
  [T4X86ID]: {
    id: T4X86ID,
    label: 'T4业务-x86',
    rule_link: 'https://help.yfanqie.com/f63a/89e1',
    prizeText: '现在加入T业务，质量达标即送15%额外奖励',
    resource_requirement: [
      '只能服务器拨号；',
      '公网IP或者NAT全锥型，单线带宽50M~500M之间（500M以上按500M算，500M以下按实际上行算） ，汇聚1G起；',
      '机械盘与固态盘混跑，固态盘实际存储是汇聚带宽的1.5倍（每G固态盘4K随机读写iops>30000），每G汇聚带宽需要单盘实际容量2T的机械盘；',
    ],
  },
  [SuperDID]: {
    id: SuperDID,
    label: 'SuperD-x86',
    prizeText: '收益最高，还享收益+15%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/7807/D',
    resource_requirement: [
      '单线路上行带宽≥500M，单机带宽≥2G；',
      '支持服务器拨号或固定ip，原始nat为公网或全锥；',
      '每G配置1T SSD；',
      '24小时起量；',
    ],
  },
  [HsX86]: {
    id: HsX86,
    label: 'Hs业务-x86',
    prizeText: '加入Hs业务，享15%质量奖励',
    rule_link: 'https://help.yfanqie.com/f63a/Hs',
    resource_requirement: [
      '单线上行≥100M，单机上行≥2G；',
      'NAT类型为公网ip或全锥型；',
      '动态ip必须使用服务拨号，静态/固定ip必须按照要求配置；',
    ],
  },
  [B2X86]: {
    id: B2X86,
    label: 'B2业务-x86',
    prizeText: '收益+25%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/B2',
    resource_requirement: [
      '单线路上行带宽≥100M，单机≥2G；',
      '支持服务器拨号或固定ip，NAT为全锥、公网；',
      '每1G配置4T硬盘，其中至少1T的SSD；',
      '缓存期为3天，缓存期后跑量会相对稳定；',
    ],
  },
  [B6X86]: {
    id: B6X86,
    label: 'B6业务-x86',
    prizeText: '加入B6业务，享15%质量奖励',
    rule_link: 'https://help.yfanqie.com/f63a/B6',
    resource_requirement: [
      '视频类业务；',
      '专线或单线上行≥100Mbps汇聚的宽带，要求公网型或全锥型；',
      '单台设备汇聚最低要求≥2G；',
      '固定ip/静态ip必须按照要求配置，动态ip必须使用服务拨号；',
    ],
  },
  [B8X86]: {
    id: B8X86,
    label: 'B8业务-x86',
    prizeText: '收益+15%质量奖，24小时起量',
    rule_link: 'https://help.yfanqie.com/f63a/B8',
    resource_requirement: [
      '单线路上行带宽≥100M，单机上行≥2G；',
      '支持服务器拨号或固定ip，NAT为全锥、映射公网、公网；',
      '每1G配置1T SSD；',
      '24小时起量，工作日跑量较高；',
    ],
  },
  [ZX86ID]: {
    id: ZX86ID,
    label: 'Z业务-x86',
    rule_link: 'https://help.yfanqie.com/f63a/10bf/Z',
    prizeText: '收益+15%奖励，单线≥50M专享',
    resource_requirement: [
      '视频类业务；',
      '单线上行≥20M，原始nat为全锥型、或公网型；',
      '1G配置4T的固态硬盘，磁盘读io≥10000；',
    ],
  },
  [T5X86ID]: {
    id: T5X86ID,
    label: 'T5业务-x86',
    rule_link: 'https://help.yfanqie.com/f63a/7807/T5',
    prizeText: '现在加入T业务，质量达标即送15%额外奖励',
    resource_requirement: [
      '只能服务器拨号；',
      '单线带宽50M~500M之间（500M以上按500M算，500M以下按实际上行算），汇聚1G起；',
      '机械盘与固态盘混跑，固态盘实际存储是汇聚带宽的2倍（每G固态盘4K随机读写iops>30000），机械盘实际存储是汇聚带宽的4倍；',
    ],
  },
  [BopX86ID]: {
    id: [BopX86ID],
    label: 'Bop业务-x86',
    prizeText: '收益+15%质量奖，24小时起量',
    rule_link: 'https://help.yfanqie.com/f63a/Bop',
    resource_requirement: [
      '单线路上行带宽≥200M，单机上行≥2G；',
      '支持服务器拨号或固定ip，NAT为全锥、映射公网、公网；',
      '每1G配置1T SSD；',
      '24小时起量，工作日跑量高；',
    ],
  },
  [SuperKID]: {
    id: SuperKID,
    label: 'SuperK-x86',
    prizeText: '奖励收益+25%，招募区域广利用率高',
    rule_link: 'https://help.yfanqie.com/f63a/7807/S',
    resource_requirement: [
      '单线路上行带宽≥500M，单机带宽≥500M；',
      '支持服务器拨号或固定ip，原始nat为公网或全锥；',
      '1G配置1.5T SSD；',
      '3天起量期；',
    ],
  },
  [B3X86]: {
    id: B3X86,
    label: 'B3业务-x86',
    prizeText: '现在加入B3业务，质量达标即送15%质量奖励',
    rule_link: 'https://help.yfanqie.com/f63a/B3',
    resource_requirement: [
      '专线或者单线≥100Mbps，要求公网ip或全锥型；',
      '动态ip必须使用服务拨号，静态/固定ip必须按照要求配置；',
      '需要固态硬盘（io≥40000），1G配置1.2T磁盘，系统盘请勿用做数据盘；',
    ],
  },
  [G3X86ID]: {
    id: G3X86ID,
    label: 'G3业务-x86',
    prizeText: '收益+15%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/G3',
    resource_requirement: [
      '单线路上行带宽≥100M（华东和华南电信、华北联通单线≥50M；西南移动单线≥30m即可），单机上行≥500M；',
      '需服务器拨号或固定ip，NAT为全锥、映射公网、公网；',
      '需配置 SSD盘，4K随机读iops≥40000。',
      '缓存部署期3天， 需保持稳定在线。',
    ],
  },
  [AX86]: {
    id: AX86,
    label: 'A业务-x86',
    prizeText: '尊享最高等级的收益+100%质量奖励加成',
    rule_link: 'https://help.yfanqie.com/f63a/7807/A',
    resource_requirement: [
      '网络单线上行≥100M ，公网ip（移动可全锥）；',
      '长视频业务，需要大容量HDD；',
      '支持软路由拨号或服务器拨号；',
    ],
  },
  [B1WPX86]: {
    id: B1WPX86,
    label: 'B1网盘-x86',
    prizeText: '奖励收益+10%，单线≥20M专享',
    rule_link: 'https://help.yfanqie.com/f63a/7807/BWP',
    resource_requirement: [
      '单线路上行带宽≥20M，单机≥200M；',
      '支持软路由拨号、服务器拨号或固定ip，nat为公网、映射公网、全锥；',
      '1G配置10T硬盘，支持SSD、HDD；',
      '7天起量期，30天缓存期，缓存完成跑量会更稳；',
    ],
  },
  [JX86ID]: {
    id: JX86ID,
    label: 'J业务-x86',
    prizeText: '单台设备仅需1T SSD，专享收益+20%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/7807/J',
    resource_requirement: [
      '单线≥100M，单机≥1G（华东华南电信单线≥50M，单机≥2G即可）；',
      '公网或nat全锥，支持服务器拨号或固定ip；',
      '工作日验收通过的当天起量，3天后跑量稳定；',
    ],
  },
  [SuperSID]: {
    id: SuperSID,
    label: 'SuperS-x86',
    prizeText: '收益最高，且专享收益+25%质量奖',
    rule_link: 'https://help.yfanqie.com/f63a/7807/S',
    resource_requirement: [
      '单线路上行带宽≥1G；',
      '支持服务器拨号或固定ip，原始nat为公网；',
      '1G配置2T SSD；',
      '3天起量期；',
    ],
  },
  [X1X86]: {
    id: X1X86,
    label: 'X1业务-x86',
    prizeText: '跑量稳定，起量快，更享15%额外奖励加成！',
    rule_link: 'https://help.yfanqie.com/f63a/c292',
    resource_requirement: [
      '每G配置1T固态盘，读iops ≥30000；',
      '网络单线上行≥200M，单机总带宽≥1G；',
      '服务器拨号，公网ip或者nat全锥型；',
    ],
  },
  [SuperD2X86]: {
    id: SuperD2X86,
    label: 'SuperD2-x86',
    prizeText: '加入定向业务专享15%额外质量奖励，',
    rule_link: 'https://help.yfanqie.com/f63a/7807/D',
    resource_requirement: [
      '服务器拨号；',
      '单线上行≥300Mbps，单机总带宽2-5G，要求全锥或公网ip；',
      '1G带宽，配置1T硬盘，不满1G按1G算，单盘需≥500G；',
    ],
  },
  [B5X86ID]: {
    id: B5X86ID,
    label: 'B5业务-x86',
    prizeText: '专享15%质量奖励加持高收益，跑量稳定，适合长期持有！',
    rule_link: 'https://help.yfanqie.com/f63a/B5',
    resource_requirement: [
      '配置固态盘，读iops ≥40000；',
      '网络单线上行≥200M ；',
      '服务器拨号，仅支持原始nat公网。',
    ],
  },
  [Z1X86ID]: {
    id: Z1X86ID,
    label: 'Z1业务-x86',
    prizeText: '收益+15%质量奖，单线≥50M带宽专享业务',
    rule_link: 'https://help.yfanqie.com/f63a/10bf/Z',
    resource_requirement: [
      '单线路上行带宽≥50M；',
      '支持软路由拨号、服务器拨号或固定ip，nat为全锥、公网、映射公网；',
      '1G配置5T SSD；',
      '7天缓存期，缓存完成跑量会更稳；',
    ],
  },
  [G2X86ID]: {
    id: G2X86ID,
    label: 'G2业务-x86',
    prizeText: '收益+15%质量奖，跑量高达80%',
    rule_link: 'https://help.yfanqie.com/f63a/7807/G2',
    resource_requirement: [
      '单线路上行带宽≥100M，单机上行在2-3G之间；',
      '支持服务器拨号或固定ip，NAT为全锥、映射公网、公网；',
      '每G配置2T SSD；',
      '24小时起量，工作日跑量高；',
    ],
  },
  [DX86ID]: {
    id: DX86ID,
    label: 'D业务-x86',
    prizeText: '专享收益+15%质量奖，需求量大且稳定',
    rule_link: 'https://help.yfanqie.com/f63a/7807/D',
    resource_requirement: [
      '单线要求：东北/西南/广东移动≥100M，华南电信≥50M，其它地区≥200M。单台设备上行≥1G；',
      '支持服务器拨号或固定ip，原始nat为公网或全锥；',
      '每G配置2T SSD；',
      '24小时起量；',
    ],
  },
  [J2X86ID]: {
    id: J2X86ID,
    label: 'J2业务-x86',
    prizeText: '9月1日前加入J2业务立享20%质量奖和15%上机奖 ',
    rule_link: 'https://help.yfanqie.com/f63a/J2',
    resource_requirement: [
      '单线上行≥100M（华东电信和华南电信单线≥50M即可），单机总带宽≥2G；',
      '服务器拨号，原始nat全锥型或公网ip；',
      '每G上行需配置1块500G硬盘；',
    ],
  },
  [T6X86ID]: {
    id: T6X86ID,
    label: 'T6业务-x86',
    prizeText: '现在加入T6业务，立享15%质量奖励',
    rule_link: 'https://help.yfanqie.com/f63a/T6',
    resource_requirement: [
      '专线或单线上行≥30M，单机≥200M；',
      '服务器拨号，nat全锥型或公网ip；',
      '需配置固态盘；',
    ],
  },
  [DzxX86ID]: {
    id: DzxX86ID,
    label: '专线D-x86',
    prizeText: '专线级优质业务，收益+35%质量奖励，值得拥有！',
    rule_link: 'https://help.yfanqie.com/f63a/Dzx',
    resource_requirement: ['单线上行≥2G；', '需静态公网ip；', '每G配置2T SSD；'],
  },
  [SzxX86ID]: {
    id: SzxX86ID,
    label: '专线S-x86',
    prizeText: '专线级优质业务，收益+35%质量奖励，值得拥有！',
    rule_link: 'https://help.yfanqie.com/f63a/Szx',
    resource_requirement: ['单线上行≥2G，单机一条线路直连；', '需静态公网ip；', '每G配置1T SSD；'],
  },
};

// 20230801：【SGPWXBOX-3032】菜单配置
// 新手指南
export const MENU_GUIDE = 'guide';
// 地区奖励
export const MENU_REWARD = 'reward';
// 加入社群
export const MENU_COMMUNITY = 'community';
// 控制台
export const MENU_CONSOLE = 'console';
// 申请记录
export const MENU_RECORD = 'record';
// x86年度活动
export const MENU_X86_ACT = 'x86Act';
// x86代理
export const MENU_X86_INVITE = 'x86Invite';
// 购买优惠
export const MENU_BOX_ACT = 'boxAct';
// 领券上机
export const MENU_BOX_INVITE = 'boxInvite';

export const X86_INDEX_TAG = 'x86';

export const BOX_INDEX_TAG = 'box';

export const RECRUIT_MENU_OPTIONS = [
  {
    type: MENU_X86_ACT,
    title: '领上机奖',
    tag: '涨价32%',
    url: `page:web_view?url=${encodeURIComponent(
      'https://h5-box.onethingpcs.com/acts/x86-addDevice9'
    )}`,
  },
  {
    type: MENU_X86_INVITE,
    title: '拿4k提成',
    tag: '',
    url: `page:web_view?url=${encodeURIComponent(
      `https://h5-box.onethingpcs.com/invite/x86/inviter`
    )}`,
  },
  // {
  //   type: MENU_X86_ACT,
  //   title: '报名领钱',
  //   url: `page:web_view?url=${encodeURIComponent('https://w.1yb.co/Km6638E')}`,
  //   tag: '100w现金',
  // },
  // {
  //   type: MENU_GUIDE,
  //   title: '新手指南',
  //   url: 'intent:https%3A%2F%2Fhelp.yfanqie.com%2Ff63a%2F88e5',
  // },
  // {
  //   type: MENU_REWARD,
  //   title: '地区奖励',
  //   tag: '',
  //   url: `page:web_view?url=${encodeURIComponent(`${window.location.origin}/recommend/region`)}`,
  // },
  {
    type: MENU_COMMUNITY,
    title: '加入社群',
    tag: '',
    url: 'intent:https%3A%2F%2Fhelp.yfanqie.com%2F1f8d%2Fd42a',
  },
  {
    type: MENU_CONSOLE,
    title: '控制台',
    tag: '',
    url: 'intent:https%3A%2F%2Fconsolepro.yfanqie.com',
  },
  {
    type: MENU_RECORD,
    title: '申请记录',
    tag: '',
  },
];

// x86定向业务页面--头部导航栏信息
export const X86_RECRUIT_MENU_OPTIONS = [
  {
    type: MENU_X86_ACT,
    title: '领上机奖',
    tag: '拿10%加成',
    // url: `page:web_view?url=${encodeURIComponent('https://w.1yb.co/Km6638E')}`,
    url: `page:web_view?url=${encodeURIComponent(`https://w.1yb.co/QyXe4eV`)}`,
  },
  {
    type: MENU_X86_INVITE,
    title: '拿4k提成',
    tag: '',
    url: `page:web_view?url=${encodeURIComponent(
      `https://h5-box.onethingpcs.com/invite/x86/inviter`
    )}`,
  },

  {
    type: MENU_COMMUNITY,
    title: '加入社群',
    tag: '',
    url: 'intent:https%3A%2F%2Fhelp.yfanqie.com%2F30d0%2F3a3f',
  },
  {
    type: MENU_CONSOLE,
    title: '控制台',
    tag: '',
    url: 'intent:https%3A%2F%2Fconsolepro.yfanqie.com',
  },
  {
    type: MENU_RECORD,
    title: '申请记录',
    tag: '',
  },
];

// 小盒子定向业务页面--头部导航栏信息
export const BOX_RECRUIT_MENU_OPTIONS = [
  {
    type: MENU_BOX_ACT,
    title: '购机特惠',
    tag: '',
    url: `page:web_view?url=${encodeURIComponent(`https://j.youzan.com/AsF-1C`)}`,
  },
  {
    type: MENU_BOX_INVITE,
    title: '免费上机',
    url: `page:web_view?url=${encodeURIComponent(
      `https://h5-box.onethingpcs.com/invite/inviter?origin=push`
    )}`,
    tag: '',
  },
  {
    type: MENU_COMMUNITY,
    title: '加入社群',
    tag: '',
    url: 'intent:https%3A%2F%2Fhelp.yfanqie.com%2F30d0%2F3a3f',
  },
  {
    type: MENU_CONSOLE,
    title: '控制台',
    tag: '',
    url: 'intent:https%3A%2F%2Fconsolepro.yfanqie.com',
  },
  {
    type: MENU_RECORD,
    title: '申请记录',
    tag: '',
  },
];
